import React from 'react';
import * as mobxReact from 'mobx-react';
import { useIntl } from 'react-intl';
import { getNavigationLabels } from '../../constants/navigation-labels.constants';
import { getOeDataNavigationLinks } from '../../constants/navigation.constants';
import { Navigation } from '../_events/_manage-event/shared/navigation/navigation';
import { OeDataTab, OeDataVM } from './oe-data.viewmodel';
import { OeDataOrganizations } from './_organizations/oe-data-organizations';

export type OeDataPresentationProps = {
    vm: OeDataVM;
};

export const OeDataTabContent = (props: { activeTab: OeDataTab }): JSX.Element => {
    switch (props.activeTab) {
        case OeDataTab.Organizations:
            return <OeDataOrganizations />;
        default:
            return null;
    }
};

export const OeDataPresentation = mobxReact.observer(({ vm }: OeDataPresentationProps): JSX.Element => {
    const intl = useIntl();

    return (
        <div className='page-container'>
            <section className='top-page-title horizontal-row horizontal-row--with-bottom-margin'>
                <h1 className='text-ellipsis'>{getNavigationLabels(intl).OE_DATA}</h1>
            </section>
            <section className='horizontal-row horizontal-row--with-bottom-margin event-tabs'>
                <Navigation links={getOeDataNavigationLinks(intl)} />
            </section>
            <OeDataTabContent activeTab={vm.getActiveTab()} />
        </div>
    );
});
